import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import "../css/breadcrumbs.css"

interface BreadcrumbItem {
    redirect: string;
    title: string;
}

interface BreadcrumbsProps {
    details: BreadcrumbItem[];
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ details }: BreadcrumbsProps) => {
    const history = useHistory()
    const redirectTo = (redirect: string) => {
        history.push(redirect)
    }
    const breadcrumbItem = (details: BreadcrumbItem[]) => {
        return details.map((objDetail: BreadcrumbItem, index: number) => {
            if (details.length !== 1 && (details.length - 1) !== index) {
                return <>
                    <li className="title-li-click">
                        <a onClick={() => redirectTo(objDetail.redirect)} className="text-blue font-bold title-font-family">
                            {objDetail.title}
                        </a>
                    </li>
                    <li className="title-li" ><span className="mx-2">{">"}</span></li>
                </>
            } else {
                return <li className="title-li title-font-family">{objDetail.title}</li>
            }
        })
    }
    return (
        <nav className="block text-sm text-left bg-gray-500 bg-opacity-10 h-12 flex items-center p-4 breadcurm-nav" >
            <ol className="list-reset flex text-grey-dark" >
                {breadcrumbItem(details)}
            </ol>
        </nav>
    );
}

export default Breadcrumbs;